import { Plus } from "lucide-react";
import { format } from "date-fns";
import { EventCard } from "./EventCard";

export function EventList({ selectedDate, events, onAddEvent, onEditEvent, onDeleteEvent }) {
  return (
    <div className="lg:col-span-5 card-base p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-white font-['Outfit']">
          {format(selectedDate, "EEEE, MMM d")}
        </h2>
        <button
          onClick={() => onAddEvent(selectedDate)}
          className="p-2 text-indigo-400 hover:bg-slate-800 rounded-lg transition-colors"
          data-testid="add-event-for-date"
        >
          <Plus size={20} />
        </button>
      </div>

      {events.length === 0 ? (
        <div className="text-center py-12 text-slate-500">
          <p>No events for this day</p>
          <button
            onClick={() => onAddEvent(selectedDate)}
            className="text-indigo-400 hover:text-indigo-300 text-sm mt-2"
          >
            Add an event
          </button>
        </div>
      ) : (
        <div className="space-y-3 max-h-[400px] overflow-y-auto">
          {events.map((event) => (
            <EventCard
              key={event.id}
              event={event}
              onEdit={onEditEvent}
              onDelete={onDeleteEvent}
            />
          ))}
        </div>
      )}
    </div>
  );
}
